import * as React from 'react';

const SvgNavApps = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M3 11h8V3H3v8Zm2-6h4v4H5V5ZM3 21h8v-8H3v8Zm2-6h4v4H5v-4ZM13 21h8v-8h-8v8Zm2-6h4v4h-4v-4ZM18 6V3h-2v3h-3v2h3v3h2V8h3V6h-3Z" })
);

export { SvgNavApps as default };
//# sourceMappingURL=NavApps.es.js.map
